import type { AdditionalInfoItem, AdditionalInfoType } from '@chewy/chat-library-common';
import styles from './AdditionalInfo.module.scss';
import Markdown from './Markdown';

export interface AdditionalInfoProps {
  additionalInfo: AdditionalInfoItem[];
  type?: AdditionalInfoType;
}

export default function AdditionalInfo({ additionalInfo, type = 'default' }: AdditionalInfoProps) {
  if (!additionalInfo || additionalInfo.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.additionalInfo} ${styles[`type-${type}`]}`}>
      <div className={styles.infoItemContainer}>
        {additionalInfo.map((item, index) => (
          <div
            key={index}
            className={`${styles.infoItem} ${item.key ? styles.hasLabel : styles.valueOnly}`}
          >
            {item.key && (
              <span className={styles.label}>{item.key}</span>
            )}
            {item.value && (
              <div className={styles.value}>
                {typeof item.value === 'string' ? (
                  <Markdown allowedElements={['strong', 'i', 'em', 'b', 'p']}>{item.value}</Markdown>
                ) : (
                  item.value
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
